import ScanWristband  from './ScanWristband';

export default ScanWristband;
